import React, { Component } from 'react';
import ConfigurationService from '../../src/services/faq.service';
import FAQSearchPage from './views/pages/FAQSearchPage'
import FAQService from '../../src/services/faq.service';


type AppProps = {
  numberOfSearchResults: number,
  labels: any,
  language: string,
  persona: string,
}

type AppState = {
  service: FAQService
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    const service: ConfigurationService = new ConfigurationService();
    this.state = {
      service: service
    };
  }

  public render() {
    return (
      <>
        {
          <FAQSearchPage service={this.state.service} language={this.props.language} persona={this.props.persona} numberOfSearchResults={this.props.numberOfSearchResults} labels={this.props.labels} ></FAQSearchPage>
        }
      </>
    );
  }
}